import React from "react";

import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";
import { DialogFooter } from "components/ui/Dialog/DialogFooter";

import { formatDate } from "../constants";

const PaymentModal = ({
  open,
  onClose,
  selectedPayment,
  modalPaymentsDue,
  isModalPaymentsLoading,
  loadingPaymentId,
  handleConfirmPayment,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={
        selectedPayment?.status === "PAID"
          ? "Payment Details"
          : "Payment Management"
      }
      width={800}
    >
      <div style={{ padding: "16px 0" }}>
        <div
          style={{
            marginBottom: "24px",
            padding: "16px",
            backgroundColor: "#f9fafb",
            borderRadius: "8px",
          }}
        >
          <h4
            style={{ margin: "0 0 8px", fontSize: "16px", fontWeight: "600" }}
          >
            Patient: {selectedPayment?.patient?.firstName}{" "}
            {selectedPayment?.patient?.surname}
            <span
              style={{
                fontSize: "12px",
                color: "#6b7280",
                fontWeight: "400",
                marginLeft: "8px",
              }}
            >
              (ID: {selectedPayment?.patient?.id})
            </span>
          </h4>
          <p style={{ margin: "0", fontSize: "14px", color: "#6b7280" }}>
            Consultation Date:{" "}
            {formatDate(
              selectedPayment?.consultation?.consultationDate ||
                selectedPayment?.consultationDate
            )}
            <span style={{ marginLeft: "16px" }}>
              | Consultation ID:{" "}
              {selectedPayment?.consultation?.id ||
                selectedPayment?.consultationId}
            </span>
          </p>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <h4
            style={{ margin: "0 0 16px", fontSize: "16px", fontWeight: "600" }}
          >
            Payment Due Records
          </h4>

          {isModalPaymentsLoading ? (
            <p
              style={{ textAlign: "center", padding: "20px", color: "#6b7280" }}
            >
              Loading payment details...
            </p>
          ) : modalPaymentsDue && modalPaymentsDue.length > 0 ? (
            <div
              style={{
                border: "1px solid #d9d8df",
                borderRadius: "8px",
                overflow: "hidden",
                backgroundColor: "#fff",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr",
                  gap: "16px",
                  padding: "12px 16px",
                  backgroundColor: "#f9fafb",
                  borderBottom: "1px solid #d9d8df",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                <div>Service</div>
                <div>Amount Due</div>
                <div>Due Date</div>
                <div>Payment Date</div>
                <div>Status</div>
                <div>Action</div>
              </div>

              {modalPaymentsDue.map((paymentDue, index) => (
                <div
                  key={paymentDue.id || index}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr",
                    gap: "16px",
                    padding: "12px 16px",
                    borderBottom:
                      index < modalPaymentsDue.length - 1
                        ? "1px solid #f3f4f6"
                        : "none",
                    fontSize: "14px",
                    color: "#374151",
                  }}
                >
                  <div>
                    {paymentDue.practiceService?.name || "Unknown Service"}
                  </div>
                  <div
                    style={{
                      fontWeight: "500",
                      color: paymentDue.paid ? "#059669" : "#dc2626",
                    }}
                  >
                    €{paymentDue.amountDue?.toFixed(2) || "0.00"}
                  </div>
                  <div>
                    {paymentDue.dueDate ? formatDate(paymentDue.dueDate) : "-"}
                  </div>
                  <div
                    style={{ color: paymentDue.paid ? "#059669" : "#6b7280" }}
                  >
                    {paymentDue.paid && paymentDue.paymentDate
                      ? formatDate(paymentDue.paymentDate)
                      : "-"}
                  </div>
                  <div>
                    <span
                      style={{
                        padding: "4px 8px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        fontWeight: "500",
                        backgroundColor: paymentDue.paid
                          ? "#ecfdf5"
                          : "#fef2f2",
                        color: paymentDue.paid ? "#059669" : "#dc2626",
                      }}
                    >
                      {paymentDue.paid ? "Paid" : "Due"}
                    </span>
                  </div>
                  <div>
                    {!paymentDue.paid ? (
                      <Button
                        size="small"
                        onClick={() => handleConfirmPayment(paymentDue)}
                        disabled={loadingPaymentId === paymentDue.id}
                      >
                        {loadingPaymentId === paymentDue.id
                          ? "Processing..."
                          : "Pay"}
                      </Button>
                    ) : (
                      <span
                        style={{
                          color: "#059669",
                          fontSize: "12px",
                          fontWeight: "500",
                        }}
                      >
                        ✓ Paid
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p
              style={{ textAlign: "center", padding: "20px", color: "#6b7280" }}
            >
              No payment due records found.
            </p>
          )}
        </div>

        <div
          style={{
            padding: "16px",
            backgroundColor:
              selectedPayment?.status === "PAID" ? "#ecfdf5" : "#f0f9ff",
            borderRadius: "8px",
            border:
              selectedPayment?.status === "PAID"
                ? "1px solid #bbf7d0"
                : "1px solid #bae6fd",
          }}
        >
          {selectedPayment?.status === "PAID" ? (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
              >
                <span style={{ fontSize: "16px", fontWeight: "600" }}>
                  Total Paid:
                </span>
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#059669",
                  }}
                >
                  €
                  {modalPaymentsDue
                    ? modalPaymentsDue
                        .filter((p) => p.paid)
                        .reduce((sum, p) => sum + (p.amountDue || 0), 0)
                        .toFixed(2)
                    : "0.00"}
                </span>
              </div>
              {modalPaymentsDue &&
                modalPaymentsDue.filter((p) => !p.paid).length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#6b7280",
                      }}
                    >
                      Remaining Outstanding:
                    </span>
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#dc2626",
                      }}
                    >
                      €
                      {modalPaymentsDue
                        .filter((p) => !p.paid)
                        .reduce((sum, p) => sum + (p.amountDue || 0), 0)
                        .toFixed(2)}
                    </span>
                  </div>
                )}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: "16px", fontWeight: "600" }}>
                Total Outstanding:
              </span>
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#dc2626",
                }}
              >
                €
                {modalPaymentsDue
                  ? modalPaymentsDue
                      .filter((p) => !p.paid)
                      .reduce((sum, p) => sum + (p.amountDue || 0), 0)
                      .toFixed(2)
                  : "0.00"}
              </span>
            </div>
          )}
        </div>
      </div>

      <DialogFooter>
        <Button variant="outline" size="large" onClick={onClose}>
          Cancel
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export { PaymentModal };
